import type { SVGProps } from 'react';

const SvgSmartphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M5 1v22h14V1zm12 18H7V5h10z" />
  </svg>
);
export default SvgSmartphone;
